export default "__VITE_ASSET__BXp8prEf__"